<template>
  <div id="app">
    <!--<web-nav></web-nav>-->
    <router-view  class="min-height"/>
    <footer>
      <!--<span>© 2021 Math Global Co., Ltd. All rights reserved.</span>-->
      <a
        href="https://twitter.com/Mathwallet"
        target="_blank"
        rel="noopener noreferrer"
      ><img src="@/static/img/foot/twitter.png" width="32"
      /></a>
      <a
        href="https://t.me/mathwalletnews"
        target="_blank"
        rel="noopener noreferrer"
      ><img src="@/static/img/foot/telegram.png" width="32"
      /></a>
      <!-- <a href="javascript:;">
        <img src="@/static/img/foot/wechat.png" width="32" />
        <img src="@/static/img/foot/wechatgroup.jpg" class="qrcode" />
      </a> -->
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  created() {
    let chain = window.location.hash?(window.location.hash.toLowerCase().match(/[\w\%]+/g)?window.location.hash.toLowerCase().match(/[\w\%]+/)[0]:'eth'):'eth';
    this.init(chain);
  },
  computed: {
    ...mapGetters({
      chainList: "chainList",
    })
  },
  methods: {
    ...mapActions(["setCurrentChain", 'setCoins', 'setCoinsInfo']),
    init(chain) {
      if (!this.chainList[chain]) {
        chain = "eth";
        this.$router.push(this.root);
      }
      // 全称
      this.setCurrentChain(chain);

      // // 连接ws 获取当前rpc
      // if (this.chainList[chain]&&!this.chainList[chain].ws) {
      //   this.setUser({chain: chain, rpc: null});
      // }

      this.getCoinList();
    },
    async getCoinList(){
      let info = await this.getCoinPub('https://market.maiziqianbao.net/');
      if (info.length > 0){
        this.coinChange(this.unit);
        let coinsList = [];
        info.map((coinInfo) =>{
          coinsList.push(coinInfo.alias);
        });
        this.setCoins(coinsList);
        this.setCoinsInfo(info);
      }
    }
  },
  // watch: {
  //   $route(to, from) {
  //     // 路由不是 /
  //     if (from.name) {
  //       let toChain = to.path.toLowerCase().match(/[\w\%]+/g)
  //         ? to.path.toLowerCase().match(/[\w\%]+/g)[0]
  //         : "evm";
  //       let fromChain = from.path.toLowerCase().match(/[\w\%]+/g)
  //         ? from.path.toLowerCase().match(/[\w\%]+/g)[0]
  //         : "evm";

  //       this.init(toChain);
  //       // 刷新页面
  //       if (fromChain != toChain) {
  //         sessionStorage.clear();
  //         window.location.reload();
  //       }
  //     }
  //   },
  // },
};
</script>

